var _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuggestionLoaderBlue1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M4.45778 1.89163C4.40474 1.5696 4.12635 1.33331 3.79998 1.33331C3.47361 1.33331 3.19522 1.5696 3.14218 1.89163C3.07551 2.29634 2.92912 2.56771 2.74365 2.75138C2.55752 2.9357 2.286 3.07722 1.89163 3.14218C1.5696 3.19522 1.33331 3.47361 1.33331 3.79998C1.33331 4.12635 1.5696 4.40474 1.89163 4.45778C2.29634 4.52445 2.56771 4.67084 2.75138 4.85631C2.9357 5.04244 3.07722 5.31396 3.14218 5.70833C3.19522 6.03036 3.47361 6.26665 3.79998 6.26665C4.12635 6.26665 4.40474 6.03036 4.45778 5.70833C4.52274 5.31396 4.66426 5.04244 4.84858 4.85631C5.03224 4.67084 5.30362 4.52445 5.70833 4.45778C6.03036 4.40474 6.26665 4.12635 6.26665 3.79998C6.26665 3.47361 6.03036 3.19522 5.70833 3.14218C5.30361 3.07551 5.03224 2.92912 4.84858 2.74365C4.66426 2.55752 4.52274 2.286 4.45778 1.89163Z",
    fill: "#0086C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26122 1.91592C9.21889 1.58291 8.93556 1.33331 8.59987 1.33331C8.26418 1.33331 7.98085 1.58291 7.93852 1.91592C7.7238 3.60537 7.26793 4.82305 6.52633 5.67748C5.79472 6.52042 4.71734 7.08705 3.09653 7.34137C2.7722 7.39226 2.5332 7.67169 2.5332 7.99998C2.5332 8.32827 2.7722 8.6077 3.09653 8.65859C4.71734 8.91291 5.79472 9.47954 6.52633 10.3225C7.26793 11.1769 7.7238 12.3946 7.93852 14.084C7.98085 14.417 8.26418 14.6666 8.59987 14.6666C8.93556 14.6666 9.21889 14.417 9.26122 14.084C9.47594 12.3946 9.93181 11.1769 10.6734 10.3225C11.405 9.47954 12.4824 8.91291 14.1032 8.65859C14.4275 8.6077 14.6665 8.32827 14.6665 7.99998C14.6665 7.67169 14.4275 7.39226 14.1032 7.34137C12.3943 7.07323 11.3157 6.47078 10.6046 5.6177C9.88047 4.74894 9.46731 3.5375 9.26122 1.91592Z",
    fill: "#0086C9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 6,
    r: 2,
    fill: "#66B8E0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 8,
    r: 2,
    fill: "#B3DBF0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 8,
    r: 2,
    fill: "#E6F4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionLoaderBlue1);
export default __webpack_public_path__ + "static/media/suggestion-loader-blue-1.f395296da3d70aa12cef0005fca4f1d7.svg";
export { ForwardRef as ReactComponent };